<script setup lang="ts">
import type { ResolvedMonospaceSingleRelationField } from '#layers/data-model/public';
import type { RenderFieldDisplayProps } from './types';
import { isNil } from '#layers/base/public';
import { useRelationFieldDisplay } from '#layers/blocks/composables/use-field-display';
import { useStableRenderBlockProps } from './use-stable-render-block-props';

interface RenderRelationFieldDisplayProps extends RenderFieldDisplayProps {
	field: ResolvedMonospaceSingleRelationField;
}

defineOptions({
	inheritAttrs: false,
});

const { field, ...forwardedProps } = defineProps<RenderRelationFieldDisplayProps>();

const forwarded = forwardedProps;

const { block, props: displayProps } = useRelationFieldDisplay(() => field);
const blockProps = useStableRenderBlockProps(() => ({
	...displayProps.value,
	...forwarded,
}));
</script>

<template>
	<DDisplayValueEmpty
		v-show="isNil(value)"
	/>
	<!--
		Hide via a wrapper we own, not the block: blocks may set `inheritAttrs: false`,
		dropping anything we'd thread through attrs to hide them and leaving their own
		empty fallback visible alongside ours. `display: contents` keeps it layout-neutral.
	-->
	<div v-if="block" v-show="!isNil(value)" class="contents">
		<BlockRender
			:block
			:props="blockProps"
			v-bind="$attrs"
		/>
	</div>
</template>
